import { ProductCard } from "@/components/common/product-card"
import { DeviceWithQty } from "@/server/api/cartActions"

export const SimilarProducts = ({
  data,
}: {
  data: DeviceWithQty[] | undefined
}) => {
  return (
    <div className="w-full h-full flex flex-col justify-center items-center my-2 ">
      <h3 className="font-orange text-2xl lg:text-4xl mt-5 lg:mt-1 mb-4 lg:mb-6">
        Similar Products
      </h3>

      <div className="w-full h-full grid grid-cols-2 xs:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 justify-items-center  gap-y-5 lg:gap-y-8 lg:px-3 mb-2 lg:mb-8">
        {data?.slice(0, 5)?.map((product, i) => (
          <ProductCard
            product={product}
            res={3}
            key={`${i}-${product.device_name}`}
          />
        ))}
      </div>
    </div>
  )
}
